export async function registerAppServiceWorker(): Promise<void> {
	if (!("serviceWorker" in navigator)) return;

	await unregisterLegacyAngularServiceWorker();

	const isAffectedSafari =
		/Version\/(16\.[0-7]|17\.[01])\D/.test(navigator.userAgent) &&
		/^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	if (isAffectedSafari || window.location.href.includes("localhost")) {
		await unregisterServiceWorkersIfSafari();
		return;
	}

	try {
		// Avoid installing a broken worker left over from a failed template
		// substitution (unresolved {{CRITICAL_ASSETS}} / {{APP_VERSION}}).
		const probe = await fetch("service-worker.js", { cache: "no-store" });
		const probeText = probe.ok ? await probe.text() : "";
		if (
			probeText.includes("{{CRITICAL_ASSETS}}") ||
			probeText.includes("{{APP_VERSION}}")
		) {
			console.warn(
				"Service worker template placeholders are unresolved; skipping registration"
			);
			const registrations = await navigator.serviceWorker.getRegistrations();
			await Promise.all(registrations.map((reg) => reg.unregister()));
			return;
		}

		// Defer registration so install/precache does not compete with the
		// first route's lazy chunks right after bootstrap.
		await new Promise<void>((resolve) => {
			if (typeof requestIdleCallback === "function") {
				requestIdleCallback(() => resolve(), { timeout: 3000 });
			} else {
				setTimeout(resolve, 1500);
			}
		});

		await navigator.serviceWorker.register("service-worker.js", {
			scope: "/",
			updateViaCache: "none",
		});
	} catch (err) {
		console.error("Service Worker registration failed:", err);
	}
}

async function unregisterLegacyAngularServiceWorker(): Promise<void> {
	try {
		const registrations = await navigator.serviceWorker.getRegistrations();
		for (const reg of registrations) {
			if (reg.active?.scriptURL.includes("ngsw-worker.js")) {
				console.info("Unregistering legacy Angular Service Worker (ngsw-worker.js)");
				await reg.unregister();
			}
		}
	} catch (err) {
		console.error("Error unregistering legacy Angular SW:", err);
	}
}

async function unregisterServiceWorkersIfSafari(): Promise<void> {
	try {
		const registrations = await navigator.serviceWorker.getRegistrations();
		for (const reg of registrations) {
			await reg.unregister();
		}
	} catch (err) {
		console.error("Error during service worker unregistration:", err);
	}
}